import { Component } from '@angular/core';
import { COMMON_IMPORTS, MATERIAL_IMPORTS } from '../../imports/common-imports';

@Component({
  selector: 'app-risk-score-diagram',
  standalone: true,
  imports: [MATERIAL_IMPORTS, COMMON_IMPORTS],
  templateUrl: './risk-score-diagram.component.html',
  styleUrl: './risk-score-diagram.component.scss',
})
export class RiskScoreDiagramComponent {
  isExpanded = false;

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}
